import type { Editor, Range } from "@tiptap/core";

type OpenHtmlUploadModalFn = (
  editor: Editor,
  range: Range,
  position?: { top: number; left: number },
  trigger?: HTMLElement | null,
) => void;

let openHtmlUploadModalFn: OpenHtmlUploadModalFn | null = null;

/** Mirrors the provider's state so a trigger can close what it opened. */
let modalState: { isOpen: boolean; from: number | null; close: () => void } = {
  isOpen: false,
  from: null,
  close: () => {},
};

export function setHtmlUploadModalState(next: { isOpen: boolean; from: number | null; close: () => void }) {
  modalState = next;
}

export function isHtmlUploadModalOpenFor(from: number): boolean {
  return modalState.isOpen && modalState.from === from;
}

export function closeHtmlUploadModal() {
  modalState.close();
}

export function setOpenHtmlUploadModal(fn: OpenHtmlUploadModalFn | null) {
  openHtmlUploadModalFn = fn;
}

export function openHtmlUploadModal(
  editor: Editor,
  range: Range,
  position?: { top: number; left: number },
  trigger?: HTMLElement | null,
) {
  if (openHtmlUploadModalFn) openHtmlUploadModalFn(editor, range, position, trigger);
  else console.warn("HtmlUploadModal not initialized.");
}
